<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import page-housing-heating
</style>

<script>
    import Grid     from '../../common/components/Grid.vue'
    import GridItem from '../../common/components/GridItem.vue'
    import Newsfeed from '../../common/components/Newsfeed.vue'
    import $ from "jquery";

    export default {
        components: {
            Grid,
            GridItem,
            Newsfeed
        },
        mounted() {
          
        },
    }
</script>
